<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Empresas</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter  v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Periodo:</label>
        <select v-if="$page.props.auth.user.rol !='Exportador'" v-model="form.trashed" class="mt-1 w-full form-select">
          <option value="siempre">Todos</option>
          <option value="hoy">Hoy</option>
        </select>       
      </search-filter>
      <inertia-link v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol=='Recepcion'" class="btn-indigo" :href="route('diarios.create')">
        <span>Crear</span>
        <span class="hidden md:inline">Establecimiento</span>
      </inertia-link>
    </div>
    <br>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap table-bordered">
        <tr class="border-t text-center font-bold">
           <th class="border-r px-6 pt-6 pb-4">Nº</th>
           <th class="border-r px-6 pt-6 pb-4">Establecimiento</th>
          <th class="border-r px-6 pt-6 pb-4">Teléfono</th>
          <th class="border-r px-6 pt-6 pb-4">Email</th>
          <th class="border-r px-6 pt-6 pb-4">Dirección</th>
          <th class="border-r px-6 pt-6 pb-4">Estado</th>
        </tr>
        <tr v-for="empresa in empresas.data" :key="empresa.id" class="border-t hover:bg-gray-100 focus-within:bg-gray-100">
           <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('empresas.edit', empresa.id)" tabindex="-1">
                {{ empresa.id }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('empresas.edit', empresa.id)" tabindex="-1">
                {{ empresa.nombre }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('empresas.edit', empresa.id)" tabindex="-1">
                {{ empresa.telefono }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('empresas.edit', empresa.id)" tabindex="-1">
                {{ empresa.email }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('empresas.edit', empresa.id)" tabindex="-1">
                {{ empresa.direccion }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('empresas.edit', empresa.id)" tabindex="-1">
                {{ empresa.estado }}
            </inertia-link>
          </td>
         
          <td class="border-r w-px">
            <inertia-link class="px-4 flex items-center" :href="route('empresas.edit', empresa.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="empresas.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encontraron ingresos</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="empresas.links" />
<br>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Empresas' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    empresas: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('empresas'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
